import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=3bf92b35"
import script from "./Routes.vue?vue&type=script&lang=ts"
export * from "./Routes.vue?vue&type=script&lang=ts"
import style0 from "./Routes.vue?vue&type=style&index=0&id=3bf92b35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports